import { AntDesign } from '@expo/vector-icons';
import { COMMON_CONSTANTS } from '@root/constants';
import colors from '@theme/colors';
import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS, AMPLITUDE_EVENT_SOURCES } from '@utils/analytics/constants';
import { Icon, Text } from 'native-base';
import React from 'react'; // , { useEffect }
import { useTranslation } from 'react-i18next';
import { Linking, Pressable } from 'react-native';

function clickHelp() {
  AmplitudeHelper.logEvent(AMPLITUDE_CONSTANTS.Login.helpClicked.name, {
    [AMPLITUDE_CONSTANTS.Login.helpClicked.attributes.source]: AMPLITUDE_EVENT_SOURCES.header,
  });
  Linking.openURL(COMMON_CONSTANTS.support);
}

function HelpButton() {
  const { t } = useTranslation('common');
  return (
    <Pressable testID="btnHelp" sentry-label="btnHelp" onPress={clickHelp}>
      <Icon as={AntDesign} name="questioncircleo" color={colors.neutral.cotton} alignSelf="center" />
      <Text testID="txtHelpBtn" color={colors.neutral.cotton} variant="xsm-normal">
        {t('common.help')}
      </Text>
    </Pressable>
  );
}

HelpButton.propTypes = {};
HelpButton.defaultProps = {};

export default HelpButton;
